import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CloseEstimate from './CloseEstimate';
import closeEstimate from '../../actions/closeEstimate';
import config from '../../helpers/config';

const mapStateToProps = ({ estimateBuilder }, ownProps) => {
  const theEstimate = estimateBuilder.entities.estimates.byId[ownProps.id];
  const safeToClose = config.repId() === null ? theEstimate.isLinked : !!theEstimate.sharedEmail;
  return { safeToClose };
};

const mapDispatchToProps = dispatch => bindActionCreators({ closeEstimate }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CloseEstimate);
